import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { EventType, EventTypeStatus, EventTypeUpsert, PagedResponse } from '../types'

const BASE = '/management/activity-event-types'

/** Silinmemiş kayıtların (sıralı) listesi. Lookup ölçeği küçük → tümünü tek sayfada çekeriz (size=200). */
export async function getEventTypes(): Promise<PagedResponse<EventType>> {
  const { data } = await apiClient.get<PagedResponse<EventType>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Yeni kayıt oluştur (201 → oluşturulan kayıt). */
export async function createEventType(body: EventTypeUpsert): Promise<EventType> {
  const { data } = await apiClient.post<EventType>(BASE, body)
  return data
}

/** Kaydı güncelle (ad/sıra; optimistic lock modDate zorunlu). */
export async function updateEventType(id: number, body: EventTypeUpsert): Promise<EventType> {
  const { data } = await apiClient.put<EventType>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeEventTypeStatus(
  id: number,
  body: EventTypeStatus,
): Promise<EventType> {
  const { data } = await apiClient.put<EventType>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteEventType(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Yeniden sıralama — ekranda görünen tüm (silinmemiş) kayıtların id sırası. Backend bu sırayı 1..N
 * SORT_INDEX olarak yeniden yazar (pairwise takas değil; çift değeri onarır). 204.
 */
export async function reorderEventTypes(orderedIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/reorder`, { orderedIds })
}

/**
 * Etkinlik türü listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportEventTypes(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'etkinlik-turleri.xlsx')
}
